/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S3_P1_BeforeInputs */

const tr_onbilgi_s3_p1_before = /** @type {(inputs: Onbilgi_S3_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet bedelleri KDV dahil, ilgili abonelik planına göre`)
};

const en_onbilgi_s3_p1_before = /** @type {(inputs: Onbilgi_S3_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service fees, KDV (VAT) included, are published in their current form according to the relevant subscription plan on the`)
};

const de_onbilgi_s3_p1_before = /** @type {(inputs: Onbilgi_S3_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Servicepreise verstehen sich inklusive KDV (MwSt.) und werden je nach Abonnementplan aktuell auf der Seite`)
};

const ru_onbilgi_s3_p1_before = /** @type {(inputs: Onbilgi_S3_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость услуг с учётом KDV (НДС) по соответствующему тарифному плану публикуется в актуальном виде на странице`)
};

/**
* | output |
* | --- |
* | "Service fees, KDV (VAT) included, are published in their current form according to the relevant subscription plan on the" |
*
* @param {Onbilgi_S3_P1_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s3_p1_before = /** @type {((inputs?: Onbilgi_S3_P1_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S3_P1_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s3_p1_before(inputs)
	if (locale === "de") return de_onbilgi_s3_p1_before(inputs)
	if (locale === "ru") return ru_onbilgi_s3_p1_before(inputs)
	return tr_onbilgi_s3_p1_before(inputs)
});